import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e0908ce")

_pushScopeId("data-v-3e0908ce")
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "full-width flex justify-center" }
const _hoisted_3 = { key: 0 }
_popScopeId()

import axios from "axios";
import { onMounted, ref, computed, watch } from "vue";
import { findFoldersWithLabel, mapToQTreeNodes } from "./DocumentationHelper";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";


export default _defineComponent({
  expose: [],
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const drawer = ref(true);
const isMainMenuHidden = computed(() => route.query.menu === "false");
const folderKey = ref<string | null>("");
const config = ref<any | null>(null);
const logoWide = require("@/assets/images/commons/logo_knowage.svg");

const selectedKey = ref<string | null>(null);
const treeNodes = ref<any[]>([]);

watch(
  [() => route.path, treeNodes],
  ([path]) => {
    const docPath = (path as string).replace(/^\/docs/, "") || null;
    if (!docPath || !treeNodes.value.length) {
      selectedKey.value = null;
      return;
    }
    const node = findNodeByPath(treeNodes.value, docPath);
    selectedKey.value = node?.id ?? null;
  },
  { immediate: true },
);

function findNodeByKey(nodes: any[], key: string): any | null {
  for (const node of nodes) {
    if (node.id === key) return node;
    if (node.children) {
      const found = findNodeByKey(node.children, key);
      if (found) return found;
    }
  }
  return null;
}

function findNodeByPath(nodes: any[], path: string): any | null {
  for (const node of nodes) {
    if (node.path === path) return node;
    if (node.children) {
      const found = findNodeByPath(node.children, path);
      if (found) return found;
    }
  }
  return null;
}

function onNodeSelect(nodeId: string | null) {
  if (!nodeId) return;
  const node = findNodeByKey(treeNodes.value, nodeId);
  if (node?.path) {
    const target = "/docs" + node.path;
    const query = config.value?.menu === false ? { ...route.query, menu: "false" } : route.query;
    router.push({ path: target, query });
  } else {
    selectedKey.value = null;
  }
}

onMounted(async () => {
  await axios
    .get(process.env.VUE_APP_API_PATH + `2.0/resources/folders`)
    .then((response: any) => {
      const root = Array.isArray(response.data.root) ? response.data.root : Array.isArray(response.data) ? response.data : [];
      const folder = findFoldersWithLabel(root, "docs")[0];
      folderKey.value = folder ? folder.key : null;
    })
    .catch(() => {
      folderKey.value = null;
    });

  if (!folderKey.value) {
    push404();
    return;
  }
  await axios
    .post(
      process.env.VUE_APP_API_PATH + `2.0/resources/files/download`,
      { key: folderKey.value, selectedFilesNames: ["config.json"] },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/zip; charset=utf-8",
        },
      },
    )
    .then(async (response: any) => {
      // Attendi che l'utente sia caricato nel store se necessario
      let user = (store.state as any).user;
      let attempts = 0;
      while (!user && attempts < 10) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        user = (store.state as any).user;
        attempts++;
      }

      const sessionRole: string | undefined = user?.sessionRole;
      const defaultRole: string | undefined = user?.defaultRole;
      const userRoles: string[] = user?.roles ?? [];
      const activeRole = sessionRole || defaultRole;

      function filterNode(node: any): any | null {
        if (node == null) return null;
        if (Array.isArray(node)) {
          return node.map(filterNode).filter((n) => n !== null);
        }
        if (typeof node !== "object") return node;

        if (Array.isArray(node.roles) && node.roles.length > 0) {
          const canSee = activeRole ? node.roles.includes(activeRole) : userRoles.some((r: string) => node.roles.includes(r));
          if (!canSee) return null;
        }

        const newNode: any = { ...node };
        if (Array.isArray(node.content)) {
          const filteredContent = node.content.map(filterNode).filter((n) => n !== null);
          if (filteredContent.length) {
            newNode.content = filteredContent;
          } else {
            delete newNode.content;
            // nasconde solo i gruppi che avevano figli ma tutti filtrati per ruolo
            if (node.content.length > 0) return null;
          }
        }
        return newNode;
      }

      const filtered = filterNode(response.data);
      if (!filtered) push404();
      else {
        config.value = filtered;
        treeNodes.value = mapToQTreeNodes(filtered.content ?? []);
      }
    })
    .catch(() => {
      push404();
    });
});

function push404() {
  config.value = null;
  router.push({ name: "404" });
}
function getLogoUrl() {
  if (config.value && config.value.logo) {
    if (typeof config.value.logo === "string" && config.value.logo.startsWith("http")) {
      return config.value.logo;
    } else {
      return logoWide;
    }
  }
  return false;
}

function onLogoError(event: Event) {
  const img = event.target as HTMLImageElement | null;
  if (!img) return;
  if (img.src !== logoWide) img.src = logoWide;
}

function toggleDrawer() {
  drawer.value = !drawer.value;
}

return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")
  const _component_q_drawer = _resolveComponent("q-drawer")
  const _component_router_view = _resolveComponent("router-view")
  const _component_q_page_container = _resolveComponent("q-page-container")
  const _component_q_layout = _resolveComponent("q-layout")

  return (config.value)
    ? (_openBlock(), _createBlock(_component_q_layout, {
        key: 0,
        view: "hHh lpR fFf",
        class: ['full-height', { 'no-main-menu': _unref(isMainMenuHidden) }]
      }, {
        default: _withId(() => [
          _createVNode(_component_q_drawer, {
            modelValue: drawer.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (drawer.value = $event)),
            side: "left",
            bordered: "",
            class: "drawer"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  (getLogoUrl())
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: getLogoUrl(),
                        class: "logo",
                        onError: onLogoError
                      }, null, 40, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                (config.value?.title)
                  ? (_openBlock(), _createBlock("h2", _hoisted_3, _toDisplayString(config.value.title), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tree, {
                  nodes: treeNodes.value,
                  dense: config.value.dense,
                  "node-key": "id",
                  "no-connectors": "",
                  "default-expand-all": "",
                  selected: selectedKey.value,
                  "onUpdate:selected": [
                    _cache[1] || (_cache[1] = ($event: any) => (selectedKey.value = $event)),
                    onNodeSelect
                  ],
                  "no-selection-unset": ""
                }, {
                  "header-section": _withId((prop) => [
                    _createVNode("span", {
                      class: ['doc-menu-node', 'doc-menu-section', { active: selectedKey.value === prop.node.id, 'no-path': !prop.node.path }]
                    }, _toDisplayString(prop.node.label), 3)
                  ]),
                  "default-header": _withId((prop) => [
                    _createVNode("span", {
                      class: ['doc-menu-node', { active: selectedKey.value === prop.node.id, 'no-path': !prop.node.path }]
                    }, _toDisplayString(prop.node.label), 3)
                  ]),
                  _: 1
                }, 8, ["nodes", "dense", "selected"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (config.value)
            ? (_openBlock(), _createBlock(_component_q_page_container, {
                key: 0,
                class: "full-height scroll relative-position"
              }, {
                default: _withId(() => [
                  _createVNode(_component_router_view, { onToggleDrawer: toggleDrawer })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})